/* The Vapetrix | v6 EXPERIMENT: "Find my device" picker behaviour + GA4 event vtx_device_picker. */
(function () {
  if (window.__vtxPickerLoaded) return;
  window.__vtxPickerLoaded = true;

  function send(name, params) {
    try {
      params = params || {};
      params.transport_type = 'beacon';
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
      else if (window.dataLayer && typeof window.dataLayer.push === 'function') { var o = { event: name }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); }
    } catch (e) { /* never break the page */ }
  }
  function loc() { return (window.Shopify && window.Shopify.locale) || document.documentElement.lang || ''; }

  var lastPointer = '';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, { passive: true, capture: true });
  document.addEventListener('keydown', function () { lastPointer = 'keyboard'; }, { passive: true, capture: true });

  /* selection: any device link (desktop panel or drawer) */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-vtx-device-link]') : null;
    if (!a) return;
    var method = e.detail === 0 ? 'keyboard' : (lastPointer === 'touch' || lastPointer === 'pen' ? 'touch' : 'mouse');
    send('vtx_device_picker', {
      action: 'select',
      device: a.getAttribute('data-device') || '',
      device_label: (a.textContent || '').trim(),
      destination_url: a.pathname || '',
      placement: a.getAttribute('data-placement') || 'header',
      method: method,
      locale: loc()
    });
  }, { passive: true, capture: true });

  /* desktop popover behaviour */
  function initPicker(root) {
    if (root.__vtxP) return; root.__vtxP = true;
    var btn = root.querySelector('.vtx-picker__btn');
    var panel = root.querySelector('.vtx-picker__panel');
    var links = [].slice.call(panel.querySelectorAll('a'));
    function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }
    function open(focusFirst) {
      if (isOpen()) return;
      panel.hidden = false; btn.setAttribute('aria-expanded', 'true');
      send('vtx_device_picker', { action: 'open', placement: 'header', method: lastPointer === 'keyboard' ? 'keyboard' : (lastPointer === 'touch' ? 'touch' : 'mouse'), locale: loc() });
      if (focusFirst && links[0]) links[0].focus();
    }
    function close(returnFocus) {
      if (!isOpen()) return;
      panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) btn.focus();
    }
    btn.addEventListener('click', function () { if (isOpen()) close(false); else open(false); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (!isOpen()) open(true); else if (links[0]) links[0].focus(); }
    });
    panel.addEventListener('keydown', function (e) {
      var i = links.indexOf(document.activeElement);
      if (e.key === 'Escape') { e.preventDefault(); close(true); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); links[(i + 1) % links.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) btn.focus(); else links[i - 1].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); links[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); links[links.length - 1].focus(); }
      else if (e.key === 'Tab') { setTimeout(function () { if (!root.contains(document.activeElement)) close(false); }, 0); }
    });
    root.addEventListener('focusout', function (e) { if (e.relatedTarget && !root.contains(e.relatedTarget)) close(false); });
    document.addEventListener('pointerdown', function (e) { if (!root.contains(e.target)) close(false); }, { passive: true });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-vtx-picker]'), initPicker); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
